import type { EntityListState } from './short-report-page.types';
import type { AgencyDto } from 'shared/dtos/agencies.dto';
import type { DivisionDto } from 'shared/dtos/divisions.dto';
import type { PolicyDto } from 'shared/dtos/policies.dto';

import { Dropdown } from 'components/dropdown/dropdown';
import { useEffect, useState } from 'react';
import AgenciesService from 'services/agencies.service';

import { AgencyReport } from './agency-report/agency-report';
import { DivisionReport } from './division-report/division-report';
import { PolicyReport } from './policy-report/policy-report';
import DivisionsService from '../../../../services/divisions.service';
import PoliciesService from '../../../../services/policies.service';
import { vocabulary } from '../../../../vocabulary/german';
import { ReportDropDown } from '../../../report-dropdown/report-dropdown';
import { Spinner } from '../../../template/spinner/spinner';

const policiesService = new PoliciesService();
const agenciesService = new AgenciesService();
const divisionsService = new DivisionsService();

export const ShortReportPage = () => {
  const [policies, setPolicies] = useState<EntityListState<PolicyDto>>({
    data: [],
    loading: true,
  });
  const [agencies, setAgencies] = useState<EntityListState<AgencyDto>>({
    data: [],
    loading: true,
  });
  const [divisions, setDivisions] = useState<EntityListState<DivisionDto>>({
    data: [],
    loading: true,
  });

  useEffect(() => {
    Promise.all([
      policiesService.getPolicies(),
      agenciesService.getAgencies(),
      divisionsService.getDivisions(),
    ]).then(([policiesRes, agenciesRes, divisionsRes]) => {
      setPolicies({ data: policiesRes.rows, loading: false });
      setAgencies({ data: agenciesRes.rows, loading: false });
      setDivisions({ data: divisionsRes.rows, loading: false });
    });
  }, []);

  const renderPolicies = policies.data.map((policy) => (
    <ReportDropDown
      key={policy.id}
      item={policy}
      name="policy"
      renderDropdown={(entityData) => <PolicyReport entityData={entityData} />}
    />
  ));

  const renderAgencies = agencies.data.map((agency) => (
    <ReportDropDown
      key={agency.id}
      item={agency}
      name="agency"
      renderDropdown={(entityData) => <AgencyReport entityData={entityData} />}
    />
  ));

  const renderDivisions = divisions.data.map((division) => (
    <ReportDropDown
      key={division.id}
      item={division}
      name="division"
      renderDropdown={(entityData) => (
        <DivisionReport entityData={entityData} />
      )}
    />
  ));

  const isContentLoaded =
    !policies.loading && !agencies.loading && !divisions.loading;

  return (
    <div className="short-report">
      {isContentLoaded ? (
        <>
          <Dropdown label={vocabulary.labels.policiesAreas}>
            {renderPolicies}
          </Dropdown>
          <Dropdown label={vocabulary.labels.agencies}>
            {renderAgencies}
          </Dropdown>
          <Dropdown label={vocabulary.labels.divisions}>
            {renderDivisions}
          </Dropdown>
        </>
      ) : (
        <Spinner />
      )}
    </div>
  );
};
